import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebase';

export const getTotalTransactionAmount = async () => {
  try {
    const snapshot = await getDocs(collection(db, "transactions"));

    const totals = {};
    snapshot.forEach(doc => {
      const data = doc.data();
      const amount = Number(data.amountSender);
      const currency = data.currencyCode || data.currency || 'USD';
      if (!isNaN(amount)) {
        totals[currency] = (totals[currency] || 0) + amount;
      }
    });

    return totals;
  } catch (error) {
    console.error("Error calculating total transaction amount:", error);
    return {};
  }
};
